<template>
  <div class="home text-center">
    <p id="header" class="d-flex justify-center">
      <v-img
        src="../assets/elements_graphiques-08.png"
        max-width="80"
        max-height="80"
        class="mx-8"
      >
      </v-img>
      Admin
    </p>
    <v-row>
      <v-col class="d-flex mx-auto" cols="6">
        <v-autocomplete
          :items="roles"
          v-model="role"
          name="Activity"
          label="Filtrer par rôle"
          color="#51bdcb"
          item-color="dark"
          chips
          multiple
          deletable-chips
        >
        </v-autocomplete>
      </v-col>
    </v-row>
    <v-simple-table class="table ">
      <template v-slot:default>
        <thead>
          <tr>
            <th>
              <v-list-item two-line class="text-center">
                <v-list-item-content>
                  <v-list-item-title>E-mail</v-list-item-title>
                </v-list-item-content>
              </v-list-item>
            </th>
            <th>
              <v-list-item two-line class="text-center">
                <v-list-item-content>
                  <v-list-item-title>Rôle</v-list-item-title>
                </v-list-item-content>
              </v-list-item>
            </th>
            <th>
              <v-list-item two-line class="text-center">
                <v-list-item-content>
                  <v-list-item-title>Opérations</v-list-item-title>
                </v-list-item-content>
              </v-list-item>
            </th>
          </tr>
        </thead>
        <tbody>
          <tr v-for="user in getAllUsers" :key="user.email">
            <template
              v-if="
                role.length == 0 ||
                  (role.length != 0 && role.includes(user.role))
              "
            >
              <td>{{ user.email }}</td>
              <td>{{ user.role }}</td>
              <td>
                <div
                  v-if="user.email != 'admin@admin.com'"
                  class="mx-auto my-2"
                >
                  <v-list-item>
                    <ModalUpdateUser
                      :getAllUsers="getAllUsers"
                      :user="user"
                      class="mx-auto"
                    />
                  </v-list-item>
                  <div v-if="user.email != getEmailToken()">
                    <v-list-item>
                      <v-btn
                        class="mx-auto"
                        color="red"
                        depressed
                        elevation="2"
                        @click="deleteUser(user.id)"
                        ><v-icon>mdi-delete</v-icon></v-btn
                      >
                    </v-list-item>
                  </div>
                </div>
              </td>
            </template>
          </tr>
        </tbody>
      </template>
    </v-simple-table>
    <br />
    <!-- Bouton création utilisateur -->
    <ModalCreateUser class="py-10" />
    <template v-if="isErrorMessageDisplayed"> <PopUpError /></template>
  </div>
</template>

<script>
import JsPDF from 'jspdf';
import ModalCreateUser from '../components/ModalCreateUser.vue';
import ModalUpdateUser from '../components/ModalUpdateUser.vue';
import { GET_ALL_USERS } from '../graphql/GraphQLQueries';
import { DELETE_USER } from '../graphql/GraphQLMutations';
import PopUpError from '../components/PopUpError.vue';

const _ = require('lodash');

export default {
  apollo: {
    getAllUsers: {
      query: GET_ALL_USERS,
      error(error) {
        if (error.graphQLErrors.length > 0) {
          if (error.graphQLErrors[0].message === 'Unauthenticated!') {
            localStorage.removeItem('apollo-token');
            this.$router.push('/');
          }
        }
        console.error(error); // eslint-disable-line no-console
      },
    },
  },

  components: {
    ModalCreateUser,
    ModalUpdateUser,
    PopUpError,
  },

  data() {
    return {
      iconModify: 'mdi-calendar-multiple',
      iconDelete: 'mdi-calendar-multiple',
      getAllUsers: [],
      roles: ['Admin', 'Utilisateur'],
      role: '',
    };
  },

  methods: {
    deleteUser(id) {
      this.isErrorMessageDisplayed = false;
      // eslint-disable-next-line no-alert
      if (window.confirm("Voulez-vous vraiment supprimer l'utilisateur ?")) {
        this.$apollo
          .mutate({
            mutation: DELETE_USER,
            variables: {
              id,
            },
            update: (cache, { data: { deleteUser } }) => {
              const data = cache.readQuery({ query: GET_ALL_USERS });
              const index = _.findIndex(data.getAllUsers, {
                id: deleteUser,
              });
              data.getAllUsers.splice(index, 1);
              cache.writeQuery({ query: GET_ALL_USERS, data });
            },
          })
          .then(() => {})
          .catch(() => {
            this.isErrorMessageDisplayed = true;
          });
      }
    },
    getEmailToken() {
      const token = localStorage.getItem('apollo-token');
      if (token) {
        const base64Url = token.split('.')[1];
        const base64 = base64Url.replace('-', '+').replace('_', '/');
        return JSON.parse(window.atob(base64)).email;
      }
      return false;
    },
    createPDF() {
      const PDFNAME = 'test';
      const DOC = new JsPDF();
      DOC.text('Hello World \n Salut', 10, 10);
      DOC.save(`${PDFNAME}.pdf`);
    },
  },
};
</script>

<style scoped>
p#header {
  font-size: 55px;
  margin: 50px;
  color: gray;
}

.custom-loader {
  animation: loader 1s infinite;
  display: flex;
}
@-moz-keyframes loader {
  from {
    transform: rotate(0);
  }
  to {
    transform: rotate(360deg);
  }
}
@-webkit-keyframes loader {
  from {
    transform: rotate(0);
  }
  to {
    transform: rotate(360deg);
  }
}
@-o-keyframes loader {
  from {
    transform: rotate(0);
  }
  to {
    transform: rotate(360deg);
  }
}
@keyframes loader {
  from {
    transform: rotate(0);
  }
  to {
    transform: rotate(360deg);
  }
}
</style>
